import React, { Component } from "react";

class QuestionBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAnswer: null,
      isAnswered: false,
      isCorrect: false,
    };
  }

  ansbtnClickHandle(index) {
    // Check if time is up or already answered
    if (!this.state.isAnswered && !this.props.timeUp) {
      const isCorrect = this.props.correctIndex === index;

      this.setState(
        {
          selectedAnswer: index,
          isAnswered: true,
          isCorrect: isCorrect,
        },
        () => {
          this.props.updateStatus(isCorrect);
        }
      );
    }
  }

  render() {
    const { question, answers, timeUp, questionNumber } = this.props;
    const { isAnswered, selectedAnswer, isCorrect } = this.state;

    return (
      <div
        style={{
          marginBottom: "20px",
          padding: "15px",
          border: "1px solid #ddd",
          borderRadius: "5px",
        }}
      >
        <h4>
          Q{questionNumber}. {question}
        </h4>
        <div>
          {answers.map((text, index) => {
            let btnClass = "btn btn-primary mx-2 my-1";
            let disabled = isAnswered || timeUp;

            if (isAnswered) {
              if (index === selectedAnswer) {
                btnClass = isCorrect
                  ? "btn btn-success mx-2 my-1"
                  : "btn btn-danger mx-2 my-1";
              }
            } else if (timeUp) {
              btnClass = "btn btn-secondary mx-2 my-1";
            }

            return (
              <button
                className={btnClass}
                key={index}
                onClick={() => this.ansbtnClickHandle(index)}
                disabled={disabled}
              >
                {text}
                {timeUp &&
                  index === this.props.correctIndex &&
                  !isAnswered &&
                  " ✓"}
              </button>
            );
          })}
        </div>
        {isAnswered && (
          <h6 className="mt-3">
            {isCorrect ? "✅ Correct!" : "❌ Ohh.... its wrong"}
          </h6>
        )}
        {timeUp && !isAnswered && (
          <h6 className="mt-3 text-warning">
            ⏰ Time's up! The correct answer was:{" "}
            {answers[this.props.correctIndex]}
          </h6>
        )}
      </div>
    );
  }
}

export default QuestionBox;
